import axios from '@/libs/axios'

const waterActions = {
    fetchWaters({commit, dispatch}, searchParams) {
        return axios.get('/waters', {params: searchParams})
    },
    getLastHorInfoSync() {
        return axios.get('/waters/last-horinfo-sync')
    },
    fetchWatersForSelect({dispatch}) {
        return new Promise((resolve, reject) => {
            axios.get('/waters/list')
                .then(response => {
                    const list = []

                    if (response.data.entities) {
                        for (const key in response.data.entities) {
                            list.push({
                                value: parseInt(response.data.entities[key].id),
                                title: response.data.entities[key].name+" ("+ response.data.entities[key].water_code +")",
                            })
                        }
                    }

                    resolve(list)
                }).catch(error => {
                reject(error)
            })
        })
    },
    fetchWater({commit, dispatch}, id) {
        return axios.get(`/waters/${id}`)
    },
    syncHorInfo() {
        return axios.post('/waters/sync-horinfo')
    },
}

export default waterActions
